import React, { useState } from "react";
// import propEq from "ramda/src/propEq";
// import pathOr from "ramda/src/pathOr";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import { Modal } from "semantic-ui-react";
// import styled from "styled-components";
import { EntrataDebug } from "../../../services/IntegrationApi";
import useAuth from "../../login/AuthContext";
import { ModalWrapper } from "../../../common/component/ModalWrapper";
// import { getDateFromArray } from "../../../helpers/getDateFromArray";
import {EntrataDebugResponse, LeaseEntry} from "../../../services/IntegrationEntrataTypes";
import {ErrorResponse} from "../../../services/Common";

interface EntrataDebuggerModalProps {
  show: boolean;
  onClose: () => void;
  entrataUserId: number;
  entrataPropertyId: number;
}

export const EntrataDebuggerModal: React.FunctionComponent<EntrataDebuggerModalProps> = ({
  show,
  onClose,
  entrataUserId,
  entrataPropertyId,
}) => {
  const [results, setResults] = useState<EntrataDebugResponse>({ leases: [] });
  const [isLoading, setIsLoading] = useState(false);
  const { getAuthToken } = useAuth();
  const [activeIndex, setActiveIndex] = useState(-1);

  const handleClick = (e: any, titleProps: any) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;

    setActiveIndex(newIndex);
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    e.stopPropagation();

    if (!e.currentTarget.checkValidity()) {
      return;
    }

    setIsLoading(true);
    const values = e.target.elements;

    try {
      const results = await EntrataDebug(
        entrataUserId,
        entrataPropertyId,
        values.firstName.value,
        values.lastName.value,
        values.customerId.value,
        await getAuthToken()
      );

      if(results === undefined){
          alert("returned undefined!!!!");
          return;
      } else if (results instanceof ErrorResponse) {
          alert(results.message);
          return;
      }

      setResults(results);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ModalWrapper open={show} onClose={onClose}>
      <Modal.Header>Debug Entrata Import</Modal.Header>

      <Modal.Content>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="firstName">
            <Form.Label>First Name</Form.Label>
            <Form.Control />
          </Form.Group>
          <Form.Group controlId="lastName">
            <Form.Label>Last Name</Form.Label>
            <Form.Control />
          </Form.Group>
          <Form.Group controlId="customerId">
            <Form.Label>Customer Id</Form.Label>
            <Form.Control />
          </Form.Group>
          <Button type="submit" variant="secondary" disabled={isLoading}>
            {isLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Searching...
              </>
            ) : (
              "Search"
            )}
          </Button>
        </Form>

        {results.leases?.map((entry: LeaseEntry, currentIndex: number) => (
          <Customer
            key={entry.lease.customers.customer[0].id}
            leaseEntry={entry}
            activeIndex={activeIndex}
            currentIndex={currentIndex}
            handleClick={handleClick}
          />
        ))}
      </Modal.Content>
    </ModalWrapper>
  );
};

interface CustomerProp {
  leaseEntry: LeaseEntry;
  activeIndex: number;
  currentIndex: number;
  handleClick: (e: any, titleProps: any) => void;
}

// const InfoDiv = styled.div`
//   margin-left: 25px;
// `;
//
// const getLease = (customerInfo: any, leaseType: any) => {
//   const applicantLeases = customerInfo.leases?.APPLICANT?.find(propEq("leaseId", leaseType.id));
//   const futureLeases = customerInfo.leases?.FUTURE?.find(propEq("leaseId", leaseType.id));
//
//   return {
//     ...leaseType,
//     startDate: applicantLeases?.startDate || futureLeases?.startDate,
//     endDate: applicantLeases?.endDate || futureLeases?.endDate,
//     applicationId: applicantLeases?.applicationId ||  futureLeases?.applicationId,
//   };
// };

const Customer: React.FunctionComponent<CustomerProp> = ({ leaseEntry, activeIndex, currentIndex, handleClick }) => (
    <div>
      <div>
        <div>raw:</div>
        <div>{JSON.stringify(leaseEntry.lease, null, 2)}</div>
      </div>
      <div>
        <div>processed:</div>
        <div>{JSON.stringify(leaseEntry.roomImportRecords, null, 2)}</div>
      </div>
      <br />
    </div>
  // <div key={customer.customerInfo.customerId}>
  //   <Accordion.Title active={activeIndex === currentIndex} index={currentIndex} onClick={handleClick}>
  //     <Icon name="dropdown" />
  //     {`${customer.customerInfo.firstName} ${customer.customerInfo.lastName}`}
  //   </Accordion.Title>
  //   <Accordion.Content active={activeIndex === currentIndex}>
  //     <InfoDiv>
  //       <div>Email: {customer.customerInfo.email}</div>
  //       <div>Customer Id: {customer.customerInfo.customerId}</div>
  //       <div>RoomSync Id: {customer.customerInfo.roomsyncId}</div>
  //       <div>
  //         Leases:{" "}
  //         {customer.leases.map((leaseType: any, leaseTypeIndex: number) => (
  //           <LeaseType key={leaseTypeIndex} lease={getLease(customer.customerInfo, leaseType)} />
  //         ))}
  //       </div>
  //     </InfoDiv>
  //   </Accordion.Content>
  // </div>
);

// interface LeaseTypeProp {
//     lease: any;
// }
//
// interface ILeaseRoommate {
//   name: string;
//   email: string;
//   leaseId: string;
// }

// const LeaseType: React.FunctionComponent<LeaseTypeProp> = ({ lease }) => (
//   <InfoDiv>
//     <div>Lease Id: {lease.id}</div>
//     <div>Application Id: {lease.applicationId}</div>
//     <div>Lease Status: {lease.leaseIntervalStatus}</div>
//     <div>Lease SubStatus: {lease.leaseSubStatus}</div>
//     <div>Lease Floor Plan: {lease.floorPlanName}</div>
//     <div>Lease Unit Id: {lease.unitId}</div>
//     <div>Lease Unit Number Space: {lease.unitNumberSpace}</div>
//     <div>Lease Space Configuration: {lease.spaceConfiguration}</div>
//     <div>Lease Month to Month: {lease.isMonthToMonth == 1 ? "true" : "false"}</div>
//     {!!lease.startDate && <div>Lease Start Date: {getDateFromArray(lease.startDate).format("MM/DD/YYYY")}</div>}
//     {!!lease.endDate && <div>Lease End Date: {getDateFromArray(lease.endDate).format("MM/DD/YYYY")}</div>}
//     {!!lease.roommates && (
//       <div>
//         Roommates:{" "}
//         {pathOr([], ["roommates", "roommate"], lease).map((roommate: ILeaseRoommate) => (
//           <RoomateType {...roommate} />
//         ))}
//       </div>
//     )}
//   </InfoDiv>
// );

// const RoomateType: React.FunctionComponent<ILeaseRoommate> = (props) => (
//   <InfoDiv>
//     <div>Name: {props.name}</div>
//     <div>Email: {props.email}</div>
//     <div>LeaseId: {props.leaseId}</div>
//     <hr />
//   </InfoDiv>
// );
